interface CalendarEvent {
  title: string;
  date: Date;
  type: string;
}

export const generateICSFile = (events: CalendarEvent[], caseName: string): string => {
  const formatDate = (date: Date): string => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//LegalCo//Case Calendar//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    `X-WR-CALNAME:${caseName} Calendar`,
  ];

  events.forEach(event => {
    const endDate = new Date(event.date);
    endDate.setHours(endDate.getHours() + 1); // Default 1-hour duration

    lines.push(
      'BEGIN:VEVENT',
      `UID:${Math.random().toString(36).substring(2)}@legalco.com`,
      `DTSTAMP:${formatDate(new Date())}`,
      `DTSTART:${formatDate(event.date)}`,
      `DTEND:${formatDate(endDate)}`,
      `SUMMARY:${event.title}`,
      `CATEGORIES:${event.type}`,
      'END:VEVENT'
    );
  });

  lines.push('END:VCALENDAR');

  return lines.join('\r\n');
};